// The "Screen size" preview (Header.js's zoom control -> TournamentPreviewFrame.js)
// loads the simulated resolutions (Large Mobile/Tablet/Laptop) in a same-origin
// iframe carrying ?preview_frame=1 - see TournamentPreviewFrame.js/App.js. Only the
// real, non-framed page (the visitor's actual device, "screen 0"/off) ever has this
// param absent, regardless of which preset width the framed copy itself renders at -
// exactly the distinction BottomSheetPanel.jsx needs to only show its match-list sheet
// on a visitor's real screen, not inside a simulated-resolution preview.
export const isPreviewFrame = () => new URLSearchParams(window.location.search).get("preview_frame") === "1";
